// extracted by mini-css-extract-plugin
export default {"overlay":"orientationPrompt__overlay__dpEhQ","spin":"orientationPrompt__spin__oIzBK"};